export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-2">
          联系我们
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">
          欢迎内容合作、投稿咨询与意见反馈
        </p>
        <div className="max-w-lg mx-auto bg-background-50 rounded-2xl border border-background-200/70 p-6 md:p-8">
          <div className="space-y-5">
            <div className="flex items-center gap-4">
              <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-mail-line text-primary-500 text-lg"></i>
              </div>
              <div>
                <p className="text-xs text-foreground-400">合作邮箱</p>
                <p className="text-sm font-medium text-foreground-800">contact@yaojingvideo.com</p>
              </div>
            </div>
            <div className="flex items-center gap-4">
              <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-chat-3-line text-accent-500 text-lg"></i>
              </div>
              <div>
                <p className="text-xs text-foreground-400">反馈建议</p>
                <p className="text-sm font-medium text-foreground-800">feedback@yaojingvideo.com</p>
              </div>
            </div>
            <div className="flex items-center gap-4">
              <div className="w-10 h-10 rounded-lg bg-secondary-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-team-line text-secondary-500 text-lg"></i>
              </div>
              <div>
                <p className="text-xs text-foreground-400">商务洽谈</p>
                <p className="text-sm font-medium text-foreground-800">biz@yaojingvideo.com</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}